<template>
  <Multiselect
    :allow-empty="false"
    :searchable="true"
    :label="label"
    value-prop="id"
    placeholder="Make selection"
    :options="asyncSource"
    :native-support="true"
    :value="modelValue"
    v-bind="$attrs"
    :class="`multiselect-${size}`"
    @input="$emit('update:modelValue', $event)">
    <template #singlelabel="option">
      <slot name="singlelabel" :option="option.value" />
    </template>
    <template #option="option">
      <slot name="option" :option="option.option" />
    </template>
    <template #placeholder>
      <slot name="placeholder" />
    </template>
    <template #multiplelabel="option">
      <slot name="multiplelabel" :option="option.values" />
    </template>
    <template #nooptions>
      <div class="multiselect-no-options">
        <slot name="nooptions">
          <div class="text-gray-500 text-sm py-2">
            No results found
          </div>
        </slot>
      </div>
    </template>
    <template #tag="{ option, handleTagRemove }">
      <slot name="tag" :option="option">
        <span class="multiselect-tag">
          <span>{{ !choppingLength ? option[label] : chopString(option[label], choppingLength) }}</span>
          <span class="multiselect-tag-remove" @click="handleTagRemove(option, $event)">
            <span class="multiselect-tag-remove-icon" />
          </span>
        </span>
      </slot>
    </template>
  </Multiselect>
</template>

<script setup>
import Multiselect from '@vueform/multiselect'

defineProps({
  modelValue: {
    required: true,
    validator: (prop) => ['string', 'object', 'number'].includes(typeof prop) || prop === null
  },
  asyncSource: { type: Function, required: true },
  // this fixes an issue when using Component:is in a loop
  options: { type: Array, required: false },
  size: {
    type: String,
    required: false,
    default: 'default',
    validator: (prop) => ['default', 'lg', 'md', 'sm'].includes(prop)
  },
  label: { type: String, default: 'title' },
  choppingLength: { type: Number, default: 0 }
})

defineEmits(['update:modelValue'])

const chopString = (str, maxlen = 15) => {
  if (str.length < maxlen) return str

  const half = Math.ceil(maxlen / 3)
  return `${str.substring(0, half)}...${str.substring(str.length - half)}`
}
</script>
